
// src/components/about/ContactInfo.jsx
import React from 'react';

const ContactInfo = () => {
  return (
    <div className="bg-gray-800 rounded-lg shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-100 mb-6">Contact</h2>
      
      <div className="space-y-4">
        
        <div className="pt-4 border-t border-gray-700">
          <h3 className="text-lg font-semibold text-gray-200 mb-2">Email</h3>
          <a className='link-opacity-100' href='mailto::mail@esbjornfalk.com'>
          <p className="text-gray-400">mail@esbjornfalk.com</p>
          </a>
        </div>
        
        {/* <div className="pt-4 border-t border-gray-700">
          <h3 className="text-lg font-semibold text-gray-200 mb-2">Social Media</h3>
          <div className="flex space-x-3 mt-3">
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700 hover:bg-gray-600 flex items-center justify-center text-gray-300 transition-colors">
              <span className="sr-only">Facebook</span>
              F
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700 hover:bg-gray-600 flex items-center justify-center text-gray-300 transition-colors">
              <span className="sr-only">Twitter</span>
              T
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700 hover:bg-gray-600 flex items-center justify-center text-gray-300 transition-colors">
              <span className="sr-only">Instagram</span>
              I
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700 hover:bg-gray-600 flex items-center justify-center text-gray-300 transition-colors">
              <span className="sr-only">YouTube</span>
              Y
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ContactInfo;